import { ReactNode, Ref } from 'react';
import StyledGridCol from './GridCol.styles';

export type SizeType = {
  startRow?: { s?: number; m?: number; l?: number };
  startCol?: { s?: number; m?: number; l?: number };
  spanRow?: { s?: number; m?: number; l?: number };
  spanCol?: { s?: number; m?: number; l?: number };
};

export interface GridColProps {
  size: SizeType;
  children: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}
const GridCol = ({ size, children, className, ref }: GridColProps) => (
  <StyledGridCol $size={size} className={className} ref={ref}>
    {children}
  </StyledGridCol>
);

export default GridCol;
